import React from 'react';
import { Fade } from 'react-slideshow-image';

// React device detect
import { isMobile } from 'react-device-detect';

// Styles
import './SlideshowComponent.styles.css';

// i18n
import { withTranslation } from 'react-i18next';

function  SlideshowComponent(props) {
  return (
    <div className="slide-container">
      <Fade
        indicators={true}
        //autoplay={false}
        arrows={isMobile? false : true}
        canSwipe={true}
      >
        {props.images.map((image, index) => (
          <div key={index}>
            <a href={image.redirect_url}>
                <img style={{ width: '100%' }} src={image.image} />           
            </a>
          </div>
        ))}
      </Fade>
    </div>
  )
}

export default withTranslation("home")(SlideshowComponent);